"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _createMixin = _interopRequireDefault(require("../utils/createMixin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = (0, _createMixin["default"])(function (theme) {
  return (0, _styledComponents.css)(["&:focus-visible{outline:none;box-shadow:0 0 0 3px ", ";}&:focus:not(:focus-visible){outline:none;box-shadow:none;}&:focus-visible:not(:focus){outline:none;box-shadow:none;}"], theme.color.focus["default"]);
});
exports["default"] = _default;
//# sourceMappingURL=applyFocus.js.map